import React from 'react';
import styles from './StartTariffRow.module.scss';
import { GiftIcon } from '../Icons/GiftIcon';

const StartTariffRow: React.FC = () => (
    <>
        <div className={styles.container}>
            <div>
                <GiftIcon />
                <span>Специальное предложение</span>
            </div>
            <div>
                <p>
                    Лицензия «Старт» на 1 участие в закупке с НМЦ до 5 млн. руб.
                    включительно — 7 500 ₽
                </p>
                <p>
                    * Использовать лицензию возможно только в течение 10
                    календарных дней с даты регистрации. Не применяется к
                    закупкам с ценой за единицу
                </p>
            </div>
        </div>
    </>
);

export default StartTariffRow;
